var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28525 0.702148C2.4161 0.702148 0.900635 2.19465 0.900635 4.03548V14.0355C0.900635 15.8763 2.4161 17.3688 4.28525 17.3688H6.42377C6.26192 18.3473 5.7918 19.3362 4.56124 19.8949C4.48025 19.9244 4.41039 19.9777 4.36105 20.0475C4.31171 20.1174 4.28526 20.2004 4.28525 20.2855C4.28525 20.396 4.32982 20.502 4.40917 20.5801C4.48851 20.6582 4.59612 20.7021 4.70833 20.7021C4.75032 20.7023 4.79209 20.6962 4.83228 20.6842C6.93793 20.6385 9.2071 19.4322 10.4364 17.3688H19.516C21.3852 17.3688 22.9006 15.8763 22.9006 14.0355V4.03548C22.9006 2.19465 21.3852 0.702148 19.516 0.702148H4.28525Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenChatIcon);
export default __webpack_public_path__ + "static/media/open-chat-icon.e81027ea228632d2f2d40f1e7972c230.svg";
export { ForwardRef as ReactComponent };